// extracted by css-extract-rspack-plugin
export default {"termsFrameContent":"termsFrameContent-YgBP2s"};